import { render, staticRenderFns } from "./ReportsDetail.vue?vue&type=template&id=a41e2928&scoped=true&"
import script from "./ReportsDetail.vue?vue&type=script&lang=js&"
export * from "./ReportsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReportsDetail.vue?vue&type=style&index=0&module=true&lang=css&"
import style1 from "./ReportsDetail.vue?vue&type=style&index=1&id=a41e2928&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a41e2928",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardText,VRow,VSimpleTable,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
